"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateInternalCustomAudienceRequestToJSON = exports.CreateInternalCustomAudienceRequestFromJSONTyped = exports.CreateInternalCustomAudienceRequestFromJSON = exports.instanceOfCreateInternalCustomAudienceRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateInternalCustomAudienceRequest interface.
 */
function instanceOfCreateInternalCustomAudienceRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "audienceId" in value;
    isInstance = isInstance && "internalAudienceId" in value;
    return isInstance;
}
exports.instanceOfCreateInternalCustomAudienceRequest = instanceOfCreateInternalCustomAudienceRequest;
function CreateInternalCustomAudienceRequestFromJSON(json) {
    return CreateInternalCustomAudienceRequestFromJSONTyped(json, false);
}
exports.CreateInternalCustomAudienceRequestFromJSON = CreateInternalCustomAudienceRequestFromJSON;
function CreateInternalCustomAudienceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'audienceId': json['audience_id'],
        'internalAudienceId': json['internal_audience_id'],
    };
}
exports.CreateInternalCustomAudienceRequestFromJSONTyped = CreateInternalCustomAudienceRequestFromJSONTyped;
function CreateInternalCustomAudienceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'audience_id': value.audienceId,
        'internal_audience_id': value.internalAudienceId,
    };
}
exports.CreateInternalCustomAudienceRequestToJSON = CreateInternalCustomAudienceRequestToJSON;
